import { JurisdictionsEnum } from '@libs/backend-common';
import { ASSET_ALTERNATIVE_CURRENCIES, ASSET_ALTERNATIVE_LABELS, ASSET_ALTERNATIVE_REAL_FIAT_LABELS, CurrencyType, } from '@libs/types';
export const getAlternativeAssetCurrency = (assetCode, jurisdictionId) => {
    if (jurisdictionId === JurisdictionsEnum.GE &&
        ASSET_ALTERNATIVE_CURRENCIES?.[assetCode]) {
        return ASSET_ALTERNATIVE_CURRENCIES[assetCode];
    }
    return assetCode;
};
export const getAlternativeAssetLabel = (assetCode, jurisdictionId) => {
    if (jurisdictionId === JurisdictionsEnum.GE &&
        ASSET_ALTERNATIVE_LABELS?.[assetCode]) {
        return ASSET_ALTERNATIVE_LABELS[assetCode];
    }
    return assetCode;
};
export const getAlternativeRealFiatAssetLabel = (assetCode) => {
    if (ASSET_ALTERNATIVE_REAL_FIAT_LABELS?.[assetCode]) {
        return ASSET_ALTERNATIVE_REAL_FIAT_LABELS[assetCode];
    }
    return assetCode;
};
export const getJurisdictionCurrencyType = (jurisdiction) => {
    if (jurisdiction === JurisdictionsEnum.EU) {
        return CurrencyType.EUR;
    }
    else if (jurisdiction === JurisdictionsEnum.UA) {
        return CurrencyType.USDT;
    }
    else {
        return CurrencyType.USD;
    }
};
//# sourceMappingURL=currency.js.map